<template>
  <div>
    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      show-close
      :size="400"
      :withHeader="false"
      append-to-body>
    <div class="drawer-box">
      <div class="title">上链信息</div>
      <div class="sub-title">源母板DNA</div>
      <div class="item">
        <div class="hash">{{digitalFingerprint}}</div>
        <div class="copy" @click="copy" :data-clipboard-text="digitalFingerprint"><img class="copy-img" src="../../../assets/imgs/common/gold-copy.png" alt=""></div>
      </div>
      <div v-if="blockchainAddress">
        <div class="sub-title">源母板区块位置</div>
        <div class="item">
          <div class="hash">{{blockchainAddress}}</div>
          <div class="copy" @click="copy" :data-clipboard-text="blockchainAddress"><img class="copy-img" src="../../../assets/imgs/common/gold-copy.png" alt=""></div>
        </div>
      </div>
      <div v-if="videoHash">
        <div class="sub-title">史瓦西聚合DNA</div>
        <div class="item">
          <div class="hash">{{videoHash}}</div>
          <div class="copy" @click="copy" :data-clipboard-text="videoHash"><img class="copy-img" src="../../../assets/imgs/common/gold-copy.png" alt=""></div>
        </div>
      </div>
      <div v-if="matrixHash">
        <div class="sub-title">矩阵源DNA</div>
        <div class="item">
          <div class="hash">{{matrixHash}}</div>
          <div class="copy" @click="copy" :data-clipboard-text="matrixHash"><img class="copy-img" src="../../../assets/imgs/common/gold-copy.png" alt=""></div>
        </div>
      </div>
      <div class="footer-content">
        CNWW3公链
        <img style="width: 24px;height: 24px;margin:5px 10px;" src="../../../assets/imgs/home/logo.png" />
        江苏省公证区块链
      </div>
    </div>
  </el-drawer>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
export default {
  data(){
    return{
      drawer:false,
      digitalFingerprint:'',
      blockchainAddress:'',
      videoHash:'',
      matrixHash:''
    }
  },
  methods: {
    show (data) {
       this.digitalFingerprint = data.digitalFingerprint
       this.blockchainAddress = data.blockchainAddress
       this.videoHash = data.videoHash
       this.matrixHash = data.matrixHash
      console.log(data);
      this.drawer =true
    },
    copy () {
      const clipboard = new Clipboard('.copy')
      clipboard.on('success', () => {
        this.$message({
          message: '复制成功',
          type: 'success'
        })
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.error('该浏览器不支持自动复制')
        clipboard.destroy()
      })
      },
    }
  }
</script>
<style lang="scss" scoped>
.drawer-box{
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  background: $sub-color;
}
.title{
  width: 100%;
  text-align: center;
  color: white;
  font-size: 18px;
  font-weight: 700;
}
.sub-title{
  color: $sub-font-color;
  font-size: 16px;
  margin: 30px 0 10px 0;
}
.item{
  width: 100%;
  height: 48px;
  color: $btn-font-color;
  border-radius: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
  background-image: linear-gradient(to right,$linear-sub-btn1,$linear-sub-btn2);
}
.hash{
  width: 80%;
  font-size: 12px;
  white-space:normal;
  word-break:break-all;
}
.copy-img{
  width: 18px;
  height: 18px;
  position: absolute;
  top: 15px;
  right: 10px;
  cursor: pointer;
}
.footer-content{
  width: 100%;
  display: flex;
  margin: 20px 0;
  background: $sub-color;
  color: white;
  justify-content: center;
  align-items: center;
}
</style>